import { render, staticRenderFns } from "./Sparkline.vue?vue&type=template&id=be5889e4&scoped=true&"
import script from "./Sparkline.vue?vue&type=script&lang=js&"
export * from "./Sparkline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5889e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VSparkline})
